import { BaseComponent } from "../BaseComponent";
import { ComponentNames } from 'src/app/helper/componentNames';


export class NonUsableSpaceComponent extends BaseComponent{
    constructor(){
        super();
        this.componentType = ComponentNames.nonUsableSpaceComponent;
    }
}